const partial = (fn:Function, ...args:any) => fn.bind(null, ...args);

export default partial;


// WEBPACK FOOTER //
// ./src/utils/partial.js